import { FC, useEffect } from "react";
import { t } from "i18next";
import { useOutletContext } from "react-router";

import ResourceDuration from "@components/Booking/ResourceDuration/ResourceDuration";
import { useBooking } from "@hooks/useBooking/useBooking";
import { BookingUnitSelect } from "@models/components/booking.model";
import {
  getLocationType,
  locationType,
  paymentRef,
  pricingRef,
} from "@models/services/organisation";
import { userProfile } from "@models/services/user";
import { ContactDetailsType } from "@models/shared/shared.model";
import { applyLocalization } from "@services/common.service";

const ResourceSelector: FC<BookingUnitSelect> = ({
  isBookingDisable,
  priceLoader,
  slots,
  unitTypeTerminology,
}) => {
  const { scrollFocusToPayment } = useBooking();
  const context: [
    getLocationType,
    locationType,
    userProfile,
    ContactDetailsType,
    paymentRef,
    pricingRef,
  ] = useOutletContext();

  useEffect(() => {
    scrollFocusToPayment();
  }, []);

  return (
    <div
      className="fg-units-section"
      data-testid="unit-select-test"
      ref={context[5]}
    >
      {slots?.resources?.length > 0 && (
        <h4 className="mb-4 fg-booking-subheading">
          {t("SelectBookingObjectDuration", {
            unitTypeTerminology: applyLocalization(
              unitTypeTerminology.singular
            ),
          })}
        </h4>
      )}
      {slots?.resources?.length ? (
        slots?.resources?.map(resource => {
          return (
            <ResourceDuration
              key={resource?.id}
              resource={resource}
              priceLoader={priceLoader}
              isBookingDisable={isBookingDisable}
            />
          );
        })
      ) : (
        <>{t("noSlots")}</>
      )}
    </div>
  );
};

export default ResourceSelector;
